module.exports = __webpack_public_path__ + "img/booking.78bc6b7b.png";